import { atoms } from '@rtkwlf/fenrir-react';
import type { ParsedQuery } from 'query-string';

import type { ItemType } from '@packages/components/dropdownSelect/MultiSelector';

export const getInitialSelectedItems = (
  query: ParsedQuery,
  field: string,
): ItemType[] => {
  const input = query[field];
  if (typeof input === 'string') {
    return [{ label: input, value: input }];
  }
  if (Array.isArray(input)) {
    const tempArr = input.filter((item) => item !== null) as string[];
    return tempArr.map((val) => ({ label: val, value: val }));
  }
  return [];
};

/** @deprecated Should be a component */
export const getFilterAtoms = (showFilter: boolean): string =>
  atoms({
    backgroundColor: 'widgetSecondary',
    display: showFilter ? 'block' : 'none',
    marginBottom: 'large',
    padding: 'default',
    width: 'full',
  });
